<template>
  <div>
    <v-dialog
      max-width="600px"
      v-model="addTagDialog">
      <AddTag
        @close="addTagDialog = false"
        @newTag="newTagAdded" />
    </v-dialog>
    <v-card class="dialog-card">
      <ModalHeader
        helpFileName="AddOrEditLocation"
        icon="mdi-filter-plus"
        :modalTitle="'Add Ingest Location'"
        @close="emit('close')" />
      <div
        :class="'mx-3 pa-3'"
        style="min-height: 300px; border-radius: 5px">
        <v-text-field
          filled
          background-color="textBoxBackground"
          label="Name"
          v-model="name"
          bg-color="var(--inner-background) !important"
          color="var(--text) !important"
          style="height: 66px"></v-text-field>
        <v-text-field
          filled
          background-color="textBoxBackground"
          label="File Directory"
          placeholder="Directory on the CanvasPro Server ie. C:\YourIngestLocationHere"
          v-model="data.location"
          bg-color="var(--inner-background) !important"
          color="var(--text) !important"
          style="height: 66px"></v-text-field>
        <div style="display: flex; gap: 8px">
          <v-autocomplete
            filled
            background-color="textBoxBackground"
            :items="Object.values(deluge.tags)"
            item-title="name"
            v-model="add_tags"
            item-value="uid"
            label="Tag Ingested Assets"
            auto-select-first
            chips
            persistent-hint
            multiple
            hint="Select tags to apply to any ingested assets from this location"
            style="height: 66px"
            :menu-props="{ closeOnContentClick: true }">
            <template #selection="{ item }">
              <v-chip
                label
                :color="item.color"
                dark>
                {{ item.name }}
              </v-chip>
            </template>
          </v-autocomplete>
          <v-btn
            variant="tonal"
            @click="addTagDialog = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>

        <v-checkbox
          v-model="data.direct_reference"
          class="mt-4"
          title="Instead of copying the files to storage, the files will be used directly from the location"
          label="Direct Reference Mode"></v-checkbox>
      </div>

      <div class="modal-footer">
        <v-btn
          block
          color="primary"
          variant="flat"
          @click="save">
          <v-icon class="ml-1 mr-2">mdi-content-save</v-icon>
          Save
        </v-btn>
      </div>
    </v-card>
  </div>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import { onMounted, ref } from 'vue';
import { $http } from '../../stores/http.js';
import { defineProps } from 'vue';
import HelpButton from '../Help-Hints/HelpButton.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
import AddTag from '../Configure/add_tag.vue';
const emit = defineEmits(['close']);
const addTagDialog = ref(false);
const props = defineProps(['selected']);
const name = ref('');
const type = ref('local_file_system');
const data = ref({
  location: '',
  direct_reference: false,
});
const add_tags = ref([]);
function newTagAdded(newTagObj) {
  add_tags.value.push(newTagObj.uid);
}
onMounted(() => {
  if (props.selected) {
    name.value = props.selected.name;
    type.value = props.selected.type;
    data.value = props.selected.data;
    add_tags.value = props.selected.tags;
  }
});
async function save() {
  var payload = {
    name: name.value,
    type: type.value,
    data: JSON.stringify(data.value),
    tags: add_tags.value,
  };
  if (!props.selected) {
    try {
      await $http(
        'POST',
        '/add_resource_location',
        JSON.stringify(payload)
      );
      emit('close');
    } catch (error) {
      console.log(error);
    }
  } else {
    payload.uid = props.selected.uid;
    try {
      await $http(
        'PUT',
        '/edit_resource_location',
        JSON.stringify(payload)
      );
      emit('close');
    } catch (error) {
      console.log(error);
    }
  }
}
</script>
